import type { FunctionComponent, ReactNode } from 'react';

import { useWelcomeOffer } from '@/domains/proB2BAnimation/hooks/useWelcomeOffer';
import DiscoutWelcomeOfferExpiredText from '@/domains/proB2BAnimation/modules/ProLanding/components/Mkt/DiscoutWelcomeOfferExpiredText';

import { DummyProBlock } from './DummyProBlock';
import ManomanoProCompactLogo from './ProIcon';
import {
  proLabel,
  proWelcomeOfferDiscount,
  proWelcomeOfferlabel,
  proWelcomeOfferlabelMultiCoupon,
} from './translations';

import styles from './styles/ProBlock.module.scss';

export interface WelcomeOfferBlockProps {
  onClick: () => void;
  url: string;
}

export const ProDiscountBlock = () => {
  const {
    amount: couponAmount,
    isExpired,
    isOfferMultiCoupon,
  } = useWelcomeOffer();

  if (!couponAmount) {
    return null;
  }

  return (
    <div className={styles.labels}>
      <span className={styles.label} data-testid="pro-block-label">
        {isExpired ? (
          <DiscoutWelcomeOfferExpiredText />
        ) : (
          (isOfferMultiCoupon
            ? proWelcomeOfferlabelMultiCoupon
            : proWelcomeOfferlabel
          ).format({
            span: (...chunks: ReactNode[]) => (
              <span key="pro-block-discount">{chunks}</span>
            ),
            discount: proWelcomeOfferDiscount.format({ couponAmount }),
          })
        )}
      </span>
      <span className={styles.sublabel}>
        {proLabel}
        <ManomanoProCompactLogo className={styles.proLogo} />
      </span>
    </div>
  );
};

export const WelcomeOfferBlock: FunctionComponent<WelcomeOfferBlockProps> = (
  props,
) => (
  <DummyProBlock {...props}>
    <ProDiscountBlock />
  </DummyProBlock>
);
